import {
    TAB,
} from '../types'

let state = {
    tab: 0,
}

const mutations = {
    [TAB](state, tab) {
        state.tab = tab;
    },
}

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/base.js